import type { RouteRecordRaw } from 'vue-router'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/auth',
    name: routeNames.auth,
    component: () => import('@/layouts/FormLayout.vue'),
    children: [
      {
        path: 'login',
        name: routeNames.authLogin,
        component: () => import('@/views/auth/PhoneEntry.vue')
      },
      {
        path: 'role-selection',
        name: routeNames.authRoleSelection,
        component: () => import('@/views/auth/RoleSelection.vue'),
        meta: {
          backToLink: routeNames.authLogin
        }
      },
      {
        path: 'signup/senior',
        name: routeNames.authSignupSenior,
        component: () => import('@/views/auth/SeniorOnboarding.vue'),
        meta: {
          backToLink: routeNames.authRoleSelection
        }
      },
      {
        path: 'signup/volunteer',
        name: routeNames.authSignupVolunteer,
        component: () => import('@/views/auth/VolunteerOnboarding.vue'),
        meta: {
          backToLink: routeNames.authRoleSelection
        }
      }
    ]
  }
]
